module.exports = __webpack_public_path__ + "static/media/54_1159.eb263b29.webp";